import { AppState } from "../store";
import { createSelector } from "reselect";
export const selectTheme = createSelector(
  (state: AppState) => state,
  state => state.theme.darkTheme,
);
